import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { ProgressCard as ProgressCardType, GenerateProgressCardProps } from '../types';
import { GenerateProgressCardItem } from './GenerateProgressCardItem';

const CardContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  '&:last-child': {
    marginBottom: 0,
  },
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '20px',
  fontWeight: 500,
  marginBottom: theme.spacing(2.5),
  lineHeight: 1.3,
}));

const ItemsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const GenerateProgressCard: React.FC<GenerateProgressCardProps> = ({ card }) => {
  const { title, items } = card;

  if (!title && (!items || items.length === 0)) {
    return null;
  }

  return (
    <CardContainer>
      {title && (
        <TitleText>
          {title}
        </TitleText>
      )}
      
      {items && items.length > 0 && (
        <ItemsContainer>
          {items
            .sort((a, b) => (a.display_order || 0) - (b.display_order || 0))
            .map((item, index) => (
              <GenerateProgressCardItem 
                key={index} 
                item={item} 
              />
            ))}
        </ItemsContainer>
      )}
    </CardContainer>
  );
};

